/**
 * @flow
 * @relayHash 8654657ceff2dcca19957123c4d81abf
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DestinationClassificationType = "COMMERCIAL" | "HOUSE" | "RESIDENTIAL_BUILDING" | "UNDEFINED" | "%future added value";
export type ReceiverPermissions = "CAN_CLASSIFY_DESTINATION" | "CAN_EDIT_FULL_ADDRESS" | "UNDEFINED" | "%future added value";
export type TrackerDestination = "LOGGI" | "RECIPIENT" | "SENDER" | "%future added value";
export type privatePackageTrackerQueryVariables = {|
  packageId: number
|};
export type privatePackageTrackerQueryResponse = {|
  +privatePackageTracker: ?{|
    +packageInfo: ?{|
      +companyName: ?string,
      +packageId: ?number,
    |},
    +recipientInfo: ?{|
      +firstName: ?string,
      +originalPhone: ?string,
    |},
    +redispatchInfo: ?{|
      +trackingCode: ?string,
      +maxPickupTime: ?number,
      +redispatchAgency: ?{|
        +name: ?string,
        +firstLine: ?string,
        +secondLine: ?string,
      |},
    |},
    +destinationInfo: ?{|
      +firstLine: ?string,
      +secondLine: ?string,
      +complement: ?string,
      +classificationType: ?DestinationClassificationType,
      +instructions: ?string,
      +additionalReceivers: ?string,
      +coordinates: ?{|
        +lat: number,
        +lng: number,
      |},
      +confirmedByRecipient: ?boolean,
    |},
    +eta: ?number,
    +currentStatus: ?{|
      +error: ?number,
      +inProgress: ?boolean,
      +destination: ?TrackerDestination,
      +type: ?string,
    |},
    +shipperStatus: ?{|
      +code: ?number,
      +label: ?string,
      +description: ?string,
      +actionRequired: ?{|
        +reasonLabel: ?string,
        +reasonDescription: ?string,
      |},
    |},
    +permissions: ?$ReadOnlyArray<ReceiverPermissions>,
    +relativeEta: ?number,
    +driverInfo: ?{|
      +firstName: string,
      +photoUrl: {|
        +default: ?string
      |},
    |},
    +currentDriverPosition: ?{|
      +lat: number,
      +lng: number,
    |},
    +shouldConfirmPackageDelivery: ?boolean,
    +receivedBy: ?string,
  |}
|};
export type privatePackageTrackerQuery = {|
  variables: privatePackageTrackerQueryVariables,
  response: privatePackageTrackerQueryResponse,
|};
*/

/*
query privatePackageTrackerQuery(
  $packageId: Int!
) {
  privatePackageTracker(packageId: $packageId) {
    packageInfo {
      companyName
      packageId
    }
    recipientInfo {
      firstName
      originalPhone
    }
    redispatchInfo {
      trackingCode
      maxPickupTime
      redispatchAgency {
        name
        firstLine
        secondLine
      }
    }
    destinationInfo {
      firstLine
      secondLine
      complement
      classificationType
      instructions
      additionalReceivers
      coordinates {
        lat
        lng
      }
      confirmedByRecipient
    }
    eta
    currentStatus {
      error
      inProgress
      destination
      type
    }
    shipperStatus {
      code
      label
      description
      actionRequired {
        reasonLabel
        reasonDescription
      }
    }
    permissions
    relativeEta
    driverInfo {
      firstName
      photoUrl {
        default
      }
    }
    currentDriverPosition {
      lat
      lng
    }
    shouldConfirmPackageDelivery
    receivedBy
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'packageId',
        type: 'Int!',
        defaultValue: null
      }
    ],
    v1 = {
      kind: 'ScalarField',
      alias: null,
      name: 'firstName',
      args: null,
      storageKey: null
    },
    v2 = {
      kind: 'ScalarField',
      alias: null,
      name: 'firstLine',
      args: null,
      storageKey: null
    },
    v3 = {
      kind: 'ScalarField',
      alias: null,
      name: 'secondLine',
      args: null,
      storageKey: null
    },
    v4 = [
      {
        kind: 'ScalarField',
        alias: null,
        name: 'lat',
        args: null,
        storageKey: null
      },
      {
        kind: 'ScalarField',
        alias: null,
        name: 'lng',
        args: null,
        storageKey: null
      }
    ],
    v5 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'privatePackageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'packageId',
            variableName: 'packageId'
          }
        ],
        concreteType: 'PrivateTrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'packageInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerPackageInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'companyName',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'packageId',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'recipientInfo',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerRecipientInfoNode',
            plural: false,
            selections: [
              (v1 /*: any*/),
              {
                kind: 'ScalarField',
                alias: null,
                name: 'originalPhone',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'redispatchInfo',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerRedispatchInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'trackingCode',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'maxPickupTime',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'redispatchAgency',
                storageKey: null,
                args: null,
                concreteType: 'PrivateTrackerAgencyInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'name',
                    args: null,
                    storageKey: null
                  },
                  (v2 /*: any*/),
                  (v3 /*: any*/)
                ]
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'destinationInfo',
            storageKey: null,
            args: null,
            concreteType: 'PrivateTrackerDestinationInfoNode',
            plural: false,
            selections: [
              (v2 /*: any*/),
              (v3 /*: any*/),
              {
                kind: 'ScalarField',
                alias: null,
                name: 'complement',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'classificationType',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'instructions',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'additionalReceivers',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'coordinates',
                storageKey: null,
                args: null,
                concreteType: 'PointNode',
                plural: false,
                selections: (v4 /*: any*/)
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'confirmedByRecipient',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'eta',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'currentStatus',
            storageKey: null,
            args: null,
            concreteType: 'TrackerStatusNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'error',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'inProgress',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'destination',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'type',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'shipperStatus',
            storageKey: null,
            args: null,
            concreteType: 'TrackerShipperStatusNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'code',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'label',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'description',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'actionRequired',
                storageKey: null,
                args: null,
                concreteType: 'PrivateActionRequiredInfoNode',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'reasonLabel',
                    args: null,
                    storageKey: null
                  },
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'reasonDescription',
                    args: null,
                    storageKey: null
                  }
                ]
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'permissions',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'relativeEta',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'driverInfo',
            storageKey: null,
            args: null,
            concreteType: 'DriverPublicNode',
            plural: false,
            selections: [
              (v1 /*: any*/),
              {
                kind: 'LinkedField',
                alias: null,
                name: 'photoUrl',
                storageKey: null,
                args: null,
                concreteType: 'PhotoUrlType',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'default',
                    args: null,
                    storageKey: null
                  }
                ]
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'currentDriverPosition',
            storageKey: null,
            args: null,
            concreteType: 'CurrentDriverPositionNode',
            plural: false,
            selections: (v4 /*: any*/)
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'shouldConfirmPackageDelivery',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'receivedBy',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'privatePackageTrackerQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v5 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'privatePackageTrackerQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v5 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'privatePackageTrackerQuery',
      id: null,
      text:
        'query privatePackageTrackerQuery(\n  $packageId: Int!\n) {\n  privatePackageTracker(packageId: $packageId) {\n    packageInfo {\n      companyName\n      packageId\n    }\n    recipientInfo {\n      firstName\n      originalPhone\n    }\n    redispatchInfo {\n      trackingCode\n      maxPickupTime\n      redispatchAgency {\n        name\n        firstLine\n        secondLine\n      }\n    }\n    destinationInfo {\n      firstLine\n      secondLine\n      complement\n      classificationType\n      instructions\n      additionalReceivers\n      coordinates {\n        lat\n        lng\n      }\n      confirmedByRecipient\n    }\n    eta\n    currentStatus {\n      error\n      inProgress\n      destination\n      type\n    }\n    shipperStatus {\n      code\n      label\n      description\n      actionRequired {\n        reasonLabel\n        reasonDescription\n      }\n    }\n    permissions\n    relativeEta\n    driverInfo {\n      firstName\n      photoUrl {\n        default\n      }\n    }\n    currentDriverPosition {\n      lat\n      lng\n    }\n    shouldConfirmPackageDelivery\n    receivedBy\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '9e8e92b48369865abd297e602505fa90';
module.exports = node;
